const SidebarMenuItemIcon = ({ icon }) => (
  <span className="menu-icon">
    <i className={`${icon} fs-3 fa-fw`} />
  </span>
)

export default SidebarMenuItemIcon
